module.exports = {
      id: "bell-usage",
      viewBox: "0 0 33 41",
      url: "img/" + "sprite.svg#bell-usage",
      toString: function () {
        return this.url;
      }
    }